import type { CompanyBrandingSectionModel, Zone } from '@seek/libs-shared';
import type { LoaderFunction } from 'react-router';

import type { RouteProps } from '../../../shared/RouteProps';
import type { CompanyDetails } from '../../../shared/services/companyDetailsService/types';

const extractCompanyIdFromSlug = (input?: string): string | undefined => {
  if (!input) {
    return undefined;
  }
  const parts = input.split('-');
  return parts[parts.length - 1];
};

const mapCompanyProfileHeroModel = (
  companyDetails: CompanyDetails,
): CompanyBrandingSectionModel => ({
  name: companyDetails.companyProfile.data.name ?? '',
  branding: companyDetails.companyProfile.data.branding
    ? {
        brandId:
          companyDetails.companyProfile.data.branding.brandId ?? undefined,
        logoImageUrl:
          companyDetails.companyProfile.data.branding.logo ?? undefined,
        coverImageUrl:
          companyDetails.companyProfile.data.branding.cover ?? undefined,
      }
    : undefined,
  rating:
    companyDetails.companyProfile.companyReviewRating?.company?.count &&
    companyDetails.companyProfile.companyReviewRating?.company?.rating
      ? {
          count:
            companyDetails.companyProfile.companyReviewRating?.company?.count,
          average:
            companyDetails.companyProfile.companyReviewRating?.company?.rating,
        }
      : undefined,
  id: companyDetails.id,
  zone: companyDetails.companyProfile.zone as Zone,
});

export const companyProfileLoader =
  ({ services }: RouteProps): LoaderFunction =>
  async ({ params, request }): Promise<CompanyBrandingSectionModel> => {
    const companyId = extractCompanyIdFromSlug(params.companySlug);

    if (companyId === undefined) {
      throw new Error('Could not find companyId from params', params);
    }

    const url = new URL(request.url);
    const isDraft = url.searchParams.get('draft') === 'true';

    const companyProfile =
      await services.companyDetailsService.getCompanyDetails(
        companyId,
        Boolean(isDraft),
      );
    return mapCompanyProfileHeroModel(companyProfile);
  };
